import { createStore } from 'vuex'

export default createStore({
  state: () => ({
    validate: false,
    monthlyPaymentSelected: false
  }),
  getters: {
  },
  mutations: {
    startInitial (state) {
      state.firstValidate = true
    },
    endInitial (state) {
      state.firstValidate = false
    },
    startValidations (state) {
      state.validate = true
    },
    endValidations (state) {
      state.validate = false
    },
    toggleMonthlyPayment (state) {
      state.monthlyPaymentSelected = !state.monthlyPaymentSelected
    }
  },
  actions: {
  },
  modules: {
  }
})
